module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3 full-width"
  }, [_c('div', {
    staticClass: "chart-heading mb-2 ml-1"
  }, [_vm._v(_vm._s(_vm.chart.name))]), _vm._v(" "), _c('div', {
    staticClass: "date-section"
  }, _vm._l((_vm.todaysTransactions), function(transaction, n) {
    return _c('div', {
      key: 'today' + n,
      staticClass: "shadow date-card"
    }, [_c('ImageGroup', {
      staticStyle: {
        "margin-top": "-20px"
      },
      attrs: {
        "images": _vm.clientImages(transaction.clients),
        "size": 70
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "heading"
    }, [_vm._v(_vm._s(_vm.clientNames(transaction.clients)))]), _vm._v(" "), _c('div', {
      staticClass: "heading",
      staticStyle: {
        "color": "#666"
      }
    }, [_vm._v(_vm._s(transaction.title))]), _vm._v(" "), _c('div', {
      staticClass: "date-bar",
      style: ({
        'background-color': transaction.color
      })
    })], 1)
  }), 0), _vm._v(" "), (!_vm.todaysTransactions.length) ? _c('NoRecordsPlaceholder', [_vm._v("\n        Nothing today!\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "chart-heading mt-2 mb-2 ml-1"
  }, [_vm._v("Tomorrow")]), _vm._v(" "), _c('div', {
    staticClass: "date-section"
  }, _vm._l((_vm.tomorrowsTransactions), function(transaction, m) {
    return _c('div', {
      key: 'today' + m,
      staticClass: "shadow date-card"
    }, [_c('ImageGroup', {
      staticStyle: {
        "margin-top": "-20px"
      },
      attrs: {
        "images": _vm.clientImages(transaction.clients),
        "size": 70
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "heading"
    }, [_vm._v(_vm._s(_vm.clientNames(transaction.clients)))]), _vm._v(" "), _c('div', {
      staticClass: "heading",
      staticStyle: {
        "color": "#666"
      }
    }, [_vm._v(_vm._s(transaction.title))]), _vm._v(" "), _c('div', {
      staticClass: "date-bar",
      style: ({
        'background-color': transaction.color
      })
    })], 1)
  }), 0), _vm._v(" "), (!_vm.tomorrowsTransactions.length) ? _c('NoRecordsPlaceholder', [_vm._v("\n        Nothing tomorrow!\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b7c8e33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Charts/UpcomingChart.vue
// module id = 2564
// module chunks = 1